<template>
  <div v-if="ready">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia'
import { useStore } from '@/store'
import { LOCALES } from '@/constants'
import AuthService from '@/services/AuthService'
import TrackingService from '@/services/TrackingService'
import '@/lib/pwc'

export default {
  computed: {
    ...mapState(useStore, ['ready']),
    ...mapWritableState(useStore, ['config'])
  },
  created () {
    const config = useRuntimeConfig()
    this.config = config.public
    AuthService.authorise(useNuxtApp())
    const trackingService = new TrackingService(this.config)
    trackingService.addScripts()
    this.setupLanguageDebugger()
  },
  methods: {
    setupLanguageDebugger () {
      window.eco = {
        language: {
          setDebug (debug) {
            const url = new URL(window.location.href)
            url.searchParams.set('debugLanguage', debug)
            window.location = url
          },
          setActive (id) {
            const lang = LOCALES.find(loc => loc.id === id)?.code
            const { $i18n } = useNuxtApp()
            $i18n.setLocale(lang)
          },
          getText (post) {
            const { $i18n } = useNuxtApp()
            return $i18n.messages.value[$i18n.localeProperties.value.code][post]
          }
        }
      }
    }
  }
}
</script>
